export default __webpack_public_path__ + "static/media/recognize-trends.172dc66a.svg";